/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_3_TitleInputs */

const en_mk_sec_3_title = /** @type {(inputs: Mk_Sec_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A transparent .bystep/ folder`)
};

const id_mk_sec_3_title = /** @type {(inputs: Mk_Sec_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folder .bystep/ yang transparan`)
};

/**
* | output |
* | --- |
* | "A transparent .bystep/ folder" |
*
* @param {Mk_Sec_3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_3_title = /** @type {((inputs?: Mk_Sec_3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_3_title(inputs)
	return en_mk_sec_3_title(inputs)
});